import React from "react";
import Switch from "react-switch";

/**
 * StatusSwitch — reusable on/off toggle matching the admin panel's
 * existing react-switch styling. Used for the Status & Premium columns.
 *
 * `onColor` lets callers give a switch a distinct active background
 * (e.g. Premium) while keeping identical sizing, animation and the
 * on/off labels. `disabled` preserves the accessible disabled state
 * (used to show a loading state during inline API updates).
 */
const StatusSwitch = ({
  checked,
  onChange,
  onLabel = "YES",
  offLabel = "NO",
  onColor = "#0093ed",
  disabled = false,
}) => (
  <Switch
    onChange={onChange}
    checked={!!checked}
    disabled={disabled}
    offColor="#C8C8C8"
    onColor={onColor}
    height={30}
    width={70}
    className="react-switch"
    uncheckedIcon={<div className="react-switch-off">{offLabel}</div>}
    checkedIcon={<div className="react-switch-on">{onLabel}</div>}
  />
);

export default StatusSwitch;
